import { Offer } from '@funtech-int/yango-shared';

import { clientConfig } from '@/config/client';

const {
    defaultMediaBillingConfig: { target: DEFAULT_MEDIA_BILLING_TARGET },
} = clientConfig;
// TODO: remove in https://st.yandex-team.ru/SAFTWEB-1093

export function getAutoOpenWidgetUrl(offer?: Offer | null): URL | undefined {
    if (!offer) {
        return undefined;
    }

    const billingFeatureName = offer.requestedFeatures?.[0];
    if (!billingFeatureName) {
        return undefined;
    }

    try {
        const url = new URL(window.location.href);
        url.searchParams.set('isOpenPw', '1');
        url.searchParams.set('billingFeatureName', billingFeatureName);
        url.searchParams.set('target', offer.target || DEFAULT_MEDIA_BILLING_TARGET);

        return url;
    } catch {
        return undefined;
    }
}
